import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Circle } from '@phosphor-icons/react';

export const PlayersStatus = ({ players, roomCode }) => {
  return (
    <div className="p-3 border-b border-[#E4E4E7] bg-[#FAFAFA]" data-testid="players-status">
      <div className="flex items-center justify-between mb-2">
        <p className="text-xs font-medium text-[#71717A] uppercase tracking-wider">Players in Room</p>
        <span className="text-xs font-mono text-[#0047FF]" data-testid="room-code-display">
          Code: {roomCode}
        </span>
      </div>
      <div className="space-y-2">
        {players.map((player) => (
          <div key={player.user_id} className="flex items-center gap-2" data-testid={`player-${player.user_id}`}>
            <Avatar className="h-7 w-7">
              <AvatarImage src={player.avatar} alt={player.username} />
              <AvatarFallback>{player.username[0]}</AvatarFallback>
            </Avatar>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-[#09090B] truncate">
                {player.username}
                <span className="ml-2 text-xs font-mono text-[#71717A]">({player.symbol})</span>
              </p>
            </div>
            <div className="flex items-center gap-1">
              <Circle 
                size={10} 
                weight="fill" 
                className={player.connected ? 'text-[#10B981] animate-pulse' : 'text-[#71717A]'} 
              />
              <span className="text-xs text-[#71717A]">
                {player.connected ? 'Connected' : 'Disconnected'}
              </span>
            </div>
          </div>
        ))}
        {players.length < 2 && (
          <div className="flex items-center gap-2 p-1 border border-dashed border-[#E4E4E7]">
            <div className="w-7 h-7 rounded-full bg-white border border-dashed border-[#E4E4E7]"></div>
            <p className="text-sm text-[#71717A] italic">Waiting for opponent...</p>
          </div>
        )}
      </div>
    </div>
  );
};
